import LBox from "@components/LBox";
import { LIconProps } from "@components/LIcon";
import LText, { Props as LTextProps } from "@components/LText";
import { LBoxProps } from "@components/LBox";
import Accordion from "../common/Accordion";
import { RichText } from "@libs/shared-ui/native";

type LocationProps = {
  city: string;
  country: string;
  venue?: string | null;
  address?: string | null;
  boxProps?: LBoxProps;
  iconProps?: Partial<LIconProps>;
  textProps?: Omit<LTextProps, "children">;
};

const Location = ({ venue, city, address, textProps }: LocationProps) => {
  // converger-created events (radio episodes) carry neither — no empty section.
  if (!venue && !address && !city) return null;
  return (
    <Accordion title="Location" initialOpen={true} disableChevron={true}>
      <LBox gap="s2">
        <LText variant="Body/B1/Medium" color="white" {...textProps}>
          {[venue, city].filter(Boolean).join(", ")}
        </LText>
        {address ? (
          <RichText
            markdown={address}
            Paragraph={({ children }) => (
              <LText
                variant="Body/B1/Regular"
                color="white"
                opacity={0.7}
                {...textProps}
              >
                {children}
              </LText>
            )}
          />
        ) : null}
      </LBox>
    </Accordion>
  );
};

export default Location;
